import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import api from "../api"; 
import logo from "../asset/images/signin_new.JPG";
import Cookies from "js-cookie";
import * as React from "react";
import { useState } from "react";
import { Navigate, NavLink, useLocation } from "react-router-dom";
import Footer from "./Footer";
import "./auth-modern.css";
import { identifyAnalyticsUser } from "../asset/js/analytics";

const theme = createTheme({
  typography: {
    fontFamily: [
      "Assistant",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default function SignIn() {
  const pageTopRef = React.useRef(null);
  const location = useLocation();
  const registrationComplete = location.state?.registrationComplete === true;
  const [wrongCredentials, setWrongCredentials] = React.useState(false);
  const [home, setHome] = useState(false);
  const [redirectTo, setRedirectTo] = useState("/");
  const [block, setBlock] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  React.useLayoutEffect(() => {
    const moveToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      pageTopRef.current?.scrollIntoView({ block: "start", inline: "nearest", behavior: "auto" });
    };

    moveToTop();
    const frame = window.requestAnimationFrame(moveToTop);
    const timer = window.setTimeout(moveToTop, 120);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isLoggingIn) return;

    setIsLoggingIn(true);
    setWrongCredentials(false);
    setBlock(false);
    const data = new FormData(event.currentTarget);

    api
      .post(`/api/login`, {
        email: data.get("email"),
        password: data.get("password"),
        token: "no",
        which: "no",
      })
      .then((data1) => {
        console.log('✅ FULL RESPONSE:', data1);
        console.log('✅ RESPONSE DATA:', data1.data);

        if (data1.status === 200) {
          if (data1.data.user.block === "block") {
            setBlock(true);
            setIsLoggingIn(false);
            return;
          }

          let favs = "";
          data1.data.user.favids.split(",").forEach((e) => {
            favs += e + "f";
          });

          Cookies.set("subscription", "No", { expires: 365 });
          localStorage.setItem("reload", "1");
          Cookies.set("favids", favs, { expires: 365 });
          localStorage.setItem("token", data1.data.access_token);
          Cookies.set("token", data1.data.access_token, { expires: 365 });
          Cookies.set("name", data1.data.user.name, { expires: 365 });
          Cookies.set("last_name", data1.data.user.last_name, { expires: 365 });
          Cookies.set("id", data1.data.user.id, { expires: 365 });
          Cookies.set("username", data1.data.user.username, { expires: 365 });
          Cookies.set("email", data1.data.user.email, { expires: 365 });
          Cookies.set("phone", data1.data.user.phone, { expires: 365 });
          Cookies.set("bio", data1.data.user.bio ?? "no", { expires: 365 });
          Cookies.set("experience", data1.data.user.experience ?? "no", { expires: 365 });
          Cookies.set("profession", data1.data.user.profession ?? "no", { expires: 365 });
          identifyAnalyticsUser();

          const token = localStorage.getItem("token");
          console.log("✅ TOKEN FROM localStorage:", token);

          // שמירת לוג ל-localStorage
          const debugInfo = {
            token: token,
            user: data1.data.user,
            time: new Date().toISOString()
          };
          localStorage.setItem("debugLog", JSON.stringify(debugInfo, null, 2));
          console.log("✅ DEBUG INFO SAVED TO localStorage:", debugInfo);
if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "LOGIN_SUCCESS",
        userId: data1.data.user.id,
        accessToken: token
      })
    );
  }
          api.get('/api/getnotifications', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            console.log("✅ TEST API RESPONSE:", response);
          })
          .catch(err => {
            console.log("❌ TEST API ERROR:", err);
          });

          setTimeout(() => {
            const savedReturnTo = sessionStorage.getItem("biditAssistantReturnTo");
            if (savedReturnTo) {
              setRedirectTo(savedReturnTo);
              sessionStorage.removeItem("biditAssistantReturnTo");
            }
            setHome(true);
          }, 2000);
        } else {
          setWrongCredentials(true);
          setIsLoggingIn(false);
        }
      })
      .catch((err) => {
        console.log("❌ LOGIN ERROR:", err);
        if (err.response) {
          console.log("❌ LOGIN ERROR STATUS:", err.response.status);
        }
        setWrongCredentials(true);
        setIsLoggingIn(false);
      });
  };

  let email = React.useRef();

  return (
    <ThemeProvider theme={theme}>
      <Container id="bidit-auth-top" ref={pageTopRef} component="main" maxWidth="xs" className="auth-modern-page" sx={{ overflowAnchor: "none", scrollMarginTop: 0 }}>
        <CssBaseline />
        <Backdrop
          open={isLoggingIn}
          role="status"
          aria-live="assertive"
          aria-label="מתבצעת התחברות לאתר"
          sx={{
            zIndex: (muiTheme) => muiTheme.zIndex.modal + 10,
            color: "#fff",
            bgcolor: "rgba(9, 27, 43, .76)",
            backdropFilter: "blur(3px)",
          }}
        >
          <Box
            dir="rtl"
            sx={{
              minWidth: { xs: 245, sm: 285 },
              px: 3,
              py: 2.6,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.4,
              borderRadius: 3,
              bgcolor: "rgba(255, 255, 255, .97)",
              color: "#173B57",
              boxShadow: "0 20px 55px rgba(0, 0, 0, .3)",
              fontFamily: "Assistant",
            }}
          >
            <CircularProgress size={38} thickness={4.5} sx={{ color: "#177DDC" }} />
            <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, fontSize: "1.08rem" }}>
              מתחברים לאתר...
            </Typography>
            <Typography sx={{ fontFamily: "Assistant", color: "#587080", fontSize: ".92rem" }}>
              אנא המתן מספר שניות
            </Typography>
          </Box>
        </Backdrop>
        {home && <Navigate to={redirectTo} />}
        <Box
          className="auth-modern-card"
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            marginTop: { xs: 0, sm: 1 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <NavLink to="/home" sx={{ textDecoration: "none" }}>
            <img
              src={logo}
              onLoad={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
                pageTopRef.current?.scrollIntoView({ block: "start", behavior: "auto" });
              }}
              style={{ objectFit: "fit-content", borderRadius: "20px" }}
              alt="פשוט למצוא בעל מקצוע לוגו"
            />
          </NavLink>
          {registrationComplete && (
            <Box
              role="status"
              sx={{
                width: "100%",
                mb: 2.5,
                p: 2,
                borderRadius: "16px",
                backgroundColor: "rgba(21, 89, 153, 0.08)",
                border: "1px solid rgba(21, 89, 153, 0.18)",
                textAlign: "center",
                fontFamily: `${process.env.REACT_APP_FONT}`,
              }}
            >
              <Typography sx={{ fontWeight: 800, color: "#153B66", fontFamily: "Assistant" }}>
                ההרשמה הושלמה בהצלחה
              </Typography>
              <Typography sx={{ mt: 0.5, color: "#48657E", fontFamily: "Assistant", fontSize: "0.95rem" }}>
                עכשיו יש להתחבר לחשבון באמצעות כתובת הדוא"ל והסיסמה שבחרת בהרשמה.
              </Typography>
            </Box>
          )}
          <Typography
            component="h1"
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
            variant="h5"
          >
            התחבר
          </Typography>
          <p
            style={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
          >
            (ניתן להתחבר עם כתובת הדוא"ל בלבד)
          </p>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 1 }}
          >
            <Typography
              variant="p"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: "bold",
              }}
            >
              כתובת דוא"ל: ​
            </Typography>
            <TextField
              margin="normal"
              required
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              fullWidth
              id="email"
              name="email"
              autoComplete="email"
              disabled={isLoggingIn}
            />
            <Typography
              variant="p"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: "bold",
              }}
            >
              סיסמא:​​
            </Typography>
            <TextField
              margin="normal"
              required
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              fullWidth
              name="password"
              type="password"
              id="password"
              autoComplete="current-password"
              disabled={isLoggingIn}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="זכור אותי​"
            />
            {wrongCredentials && (
              <p
                style={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  color: "red",
                }}
              >
                דוא"ל או סיסמא אינם נכונים​
              </p>
            )}
            {block && (
              <p
                style={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  color: "red",
                }}
              >
                נחסמת על ידי האתר, צור קשר עם התמיכה
              </p>
            )}
            <Button
              type="submit"
              disabled={isLoggingIn}
              fullWidth
              variant="contained"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                mt: 3,
                mb: 2,
                backgroundColor: 'black',
                color: 'white',
                minHeight: 46,
                "&.Mui-disabled": {
                  backgroundColor: "#303030",
                  color: "white",
                },
              }}
            >
              {isLoggingIn ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  <CircularProgress size={21} thickness={5} sx={{ color: "white" }} />
                  <span>מתחברים לאתר...</span>
                </Box>
              ) : (
                "התחבר"
              )}
            </Button>

            <Box aria-live="polite" role="status" sx={{ minHeight: 22, textAlign: "center" }}>
              {isLoggingIn && (
                <Typography sx={{ fontFamily: "Assistant", color: "#48657E", fontSize: ".92rem" }}>
                  אנא המתן, אנו מחברים אותך לחשבון
                </Typography>
              )}
            </Box>

            <Grid container sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
              <Grid item xs>
                <NavLink to="/forgot" style={{ fontFamily: 'Assistant, sans-serif' }}>שכחת סיסמא?</NavLink>
              </Grid>
            </Grid>
            <NavLink to="/signupwithphone" style={{ fontFamily: 'Assistant, sans-serif' }} variant="body2">
              {"הרשם כלקוח​"}
            </NavLink>
            <NavLink to="/signupasprof" style={{ fontFamily: 'Assistant, sans-serif', display: 'block' }} variant="body2">
              {"הרשם כבעל מקצוע"}
            </NavLink>
          </Box>
        </Box>
   
      </Container>
       <Footer/>
    </ThemeProvider>
  );
}
